// apps/web/src/services/api.js
import axios from "axios";
import { AUTH_TOKEN } from "constants/AuthConstant";
import API_URL from "configs/apiConfig";

// mesmas chaves usadas no AuthService/authSlice
const ACTIVE_COMPANY_ID = "activeCompanyId";
export const AUTH_USER = "AUTH_USER";

/**
 * Instância principal do Axios (ÚNICA)
 * - Produção: /api (proxy pelo Caddy/Nginx)
 * - Dev: http://localhost:3000
 */
const api = axios.create({
  baseURL: API_URL,
});

function safeJsonParse(raw) {
  try {
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function clearSessionAndRedirect() {
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem("token");
  localStorage.removeItem(AUTH_USER);
  localStorage.removeItem("companyId");
  localStorage.removeItem(ACTIVE_COMPANY_ID);

  if (window.location.pathname !== "/auth/login") {
    window.location.href = "/auth/login";
  }
}

function resolveCompanyId() {
  // 1) companyId direto
  const rawCompanyId = localStorage.getItem("companyId");
  const companyIdNum = rawCompanyId ? Number(rawCompanyId) : null;
  if (Number.isFinite(companyIdNum) && companyIdNum > 0) {
    return String(companyIdNum);
  }

  // 2) activeCompanyId
  const rawActive = localStorage.getItem(ACTIVE_COMPANY_ID);
  const activeNum = rawActive ? Number(rawActive) : null;
  if (Number.isFinite(activeNum) && activeNum > 0) {
    // sincroniza compat
    localStorage.setItem("companyId", String(activeNum));
    return String(activeNum);
  }

  // 3) AUTH_USER.activeCompanyId (fallback)
  const user = safeJsonParse(localStorage.getItem(AUTH_USER));
  const userActive = user?.activeCompanyId ? Number(user.activeCompanyId) : null;

  if (Number.isFinite(userActive) && userActive > 0) {
    localStorage.setItem(ACTIVE_COMPANY_ID, String(userActive));
    localStorage.setItem("companyId", String(userActive));
    return String(userActive);
  }

  // inválido: limpa pra não ficar “sujando”
  if (rawCompanyId) localStorage.removeItem("companyId");
  if (rawActive) localStorage.removeItem(ACTIVE_COMPANY_ID);

  return null;
}

/**
 * Interceptor de request:
 * - JWT Bearer token
 * - Multi-empresa: x-company-id
 */
api.interceptors.request.use(
  (config) => {
    const token =
  localStorage.getItem(AUTH_TOKEN) ||
  localStorage.getItem("AUTH_TOKEN") ||
  localStorage.getItem("token") ||
  localStorage.getItem("auth_token") ||
  localStorage.getItem("accessToken");

    config.headers = config.headers || {};

    // Authorization
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }

    // x-company-id (somente se válido)
    const companyId = resolveCompanyId();
    if (companyId) {
      config.headers["x-company-id"] = companyId;
    } else {
      delete config.headers["x-company-id"];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Interceptor de response:
 * - Se token expirou / sessão inválida => limpa tudo e volta para login
 */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = String(error?.config?.url || "");

    // evita loop em endpoints de auth
    const isAuthRoute =
      requestUrl.includes("/auth/login") ||
      requestUrl.includes("/auth/me") ||
      requestUrl.includes("/auth/refresh");

    if (status === 401 && !isAuthRoute) {
      clearSessionAndRedirect();
    }

    return Promise.reject(error);
  }
);

export default api;